import { isTypeCardsSection } from '@platform/contentful';
import cx from 'classix';
import { Entry } from 'contentful';
import ContentfulCard from './ContentfulCard';
import Divider from './util/Divider';
import { getFullWidthBackgroundStyles } from './util/utils';

const ContentfulCardsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeCardsSection(entry)) {
    return null;
  }

  return (
    <div className={getFullWidthBackgroundStyles(entry)}>
      <div className='max-w-[1440px] mx-auto flex flex-col text-center items-center'>
        <h1 className='max-w-3xl w-full font-header font-bold text-4xl sm:text-5xl text-gray-500 my-3'>
          {entry.fields.header}
        </h1>
        <h2 className='max-w-3xl w-full font-header font-medium text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-400'>
          {entry.fields.subHeader}
        </h2>
        <div className='mx-auto'>
          <Divider />
        </div>
        <div className='flex flex-col justify-center sm:flex-row sm:flex-wrap gap-8'>
          {entry.fields.cards?.map((card) => (
            /* This div is a bad hack that accounts for the legacy app applying different sizing styles to different uses of
             * ContentfulCardSection. Somehow, they set these to 1/3 screen width to equal sizing in some cases while otherwise
             * allow to overflow as two columns. See /skills-based-volunteering-platform for an example of both versions on one page.
             * Need to verify this approach works for other pages. */
            <div
              key={card?.sys.id}
              className={cx(
                entry.fields.cards?.length === 3 ?
                  'sm:max-w-[30%] flex-1/3'
                : 'sm:max-w-[45%] flex-1/2',
              )}
            >
              <ContentfulCard entry={card} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentfulCardsSection;
